export default __webpack_public_path__ + "static/media/metamask512.c09c031b.png";